const TOKEN_KEY = 'enterprise-weekly-token';
const USER_KEY = 'enterprise-weekly-user';

export const getToken = () => window.localStorage.getItem(TOKEN_KEY) || '';

export const setToken = (token) => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
};

export const getUserCache = () => {
  const raw = window.localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const setUserCache = (user) => {
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
};

